module.exports = __webpack_public_path__ + "img/profile.009d04d5.svg";